import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
const PlusCircleIcon = ({ className }) => (_jsx("svg", Object.assign({ className: `svg-plus-circle-icon ${className}`, height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsxs("g", Object.assign({ transform: 'translate(-916 -2856)' }, { children: [_jsx("rect", { fill: 'rgba(0,0,0,0)', height: '24', transform: 'translate(916 2856)', width: '24' }), _jsx("path", { d: 'M936,2878h-8a10,10,0,1,1,10-10v8A2,2,0,0,1,936,2878Zm-8-18a8,8,0,1,0,8,8A8.009,8.009,0,0,0,928,2860Zm0,13a1,1,0,0,1-1-1v-3h-3a1,1,0,1,1,0-2h3v-3a1,1,0,1,1,2,0v3h3a1,1,0,1,1,0,2h-3v3A1,1,0,0,1,928,2873Z', fill: '#fff' })] })) })));
PlusCircleIcon.propTypes = {
    className: propStr(),
};
PlusCircleIcon.defaultProps = {
    className: '',
};
export default PlusCircleIcon;
